import { Resource } from 'rest-hooks';
import Serializer from '@contently/simple-json-api-resource-seralizer';
import { stringify } from 'qs';

const mapper = new Serializer();

export default class BaseResource extends Resource {
  static async fetch(method = 'get', url, body = {}, jsonApi = true) {
    let response = await super.fetch(method, url, body);
    if (jsonApi) {
      response = await mapper.deserialize(response);
    }
    return response;
  }

  static getFetchOptions() {
    return { invalidIfStale: true };
  }

  // Override to add support for array params
  static listUrl(searchParams) {
    if (Object.keys(searchParams).length) {
      return `${this.urlRoot}?${stringify(searchParams, { arrayFormat: 'brackets' })}`;
    }
    return this.urlRoot;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/client/resources/BaseResource.js